import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { privateRoutes, publicRoutes } from '../router';
import { RootState } from '../store';
import { useSelector } from 'react-redux';


const AppRouter = () => {
  const isAuth = useSelector((state: RootState) => state.users.auth);
  const routes = !isAuth ? publicRoutes : privateRoutes;

  return (
    <Routes>
      {routes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={<route.element />}
        />
      ))}
    </Routes>
  );
};

export default AppRouter;
